const toSentenceCase = (string: string): string => {
  return string
    ? (string.substring(0, 1).toUpperCase() + string.substring(1))
        .split('_')
        .join(' ')
    : '';
};

export default toSentenceCase;
